export const PATH_NAME = {
  ROOT: '/',
  ADMIN: '/admin',
  USERS: 'users',
  BRANCHES: 'branches',
  LOCALES: 'locales',
  QR_BOXES: 'qr-boxes',
  CATEGORIES: 'categories',
  ANSWERS: 'answers',
  QUESTIONS: 'questions',
  FOOTERS: 'footers',
  DASHBOARD: 'dashboard',
  DASHBOARD_REVIEW: 'review',
  DASHBOARD_STATISTICS: 'statistics',
  ORDERS: 'orders',
  SETTINGS: 'settings',
  SETTINGS_MENU: 'setting-general',
  MENU: 'menu',
  LIBRARY: 'library',

  STORES: 'stores',
  PLANS: 'plans',
  EXPORTS: 'exports',
  REQUEST_PERMISSION_EXPORT: 'request-permission-export',
  DASHBOARD_PROGRESS: 'progress',
  DASHBOARD_PERFORMANCE_PROGRESS: 'performance-progress',
  DASHBOARD_RESULT_CHART: 'result',
  DASHBOARD_MAP: 'map',
  DASHBOARD_SURVEY: 'survey',
  PHONE_CARDS: 'phone-cards',

  CUSTOMER_ORDER: '/orders',
  LOGIN: '/login',
  PRODUCTS: 'products',
  CUSTOMERS: 'customers',
  LOGS: 'logs',
  PROFILE: 'profile',
  USER: 'user',
  SHOPS: 'shops',
};

export const PATH_NAME_ACTION = {
  CREATE: 'create',
  EDIT: 'edit',
};
